// export class Const {    
//     static readonly GAME_SNAPSHOT = 'game-snapshot';
//     static readonly GAME_PATCH = 'game-patch';
// }

export const consts = {
     APP_SNAPSHOT: 'app-snapshot',
     APP_PATCH: 'app-patch',

     APP_AVATAR: 'app-avatar',
     APP_AVATAR_SELF: 'app-avatar-self',

     HOST_INFO: 'host-info',
     USER_INFO: 'user-info',

     // -------
     GAME_LOADED: 'game-loaded',
     GAME_SNAPSHOT: 'game-snapshot',
     GAME_PATCH: 'game-patch',
     GAME_MESSAGE: 'game-message',

     // Tested using "sample-avatar-5.jpg". This was the largest data url between the files 1-5
     // @1204px it's 375.11kb
     // @512px it's 123.69kb
     // @256px it's 31.17kb - Went for this as a good balance, especially for hight DPI screens (on mobile phones - though still untested on such phones)
     // @128px it's 9.53kb - this is acceptable in the Avatar Selector UI on Windows
     // @64px it's 3.60kb - this is **too** pixellated in the Avatar Selector UI on Windows
     avatar: {
          width: 256,
          height: 256,
     },

     chars: {
          nbsp: "\u00A0",
          // ellipsis: '…',
     }
}
